<template>
  <div class="game">
    <div class="action-part">
      <el-form :inline="true" size="medium">
        <el-form-item>
          <el-button type="primary" @click="showEditor(null)">创建游戏</el-button>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入游戏名称（英语/拼音）" v-model="search.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入游戏名称（中文）" v-model="search.label"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doSearch">查 询</el-button>
          <el-button type="info" @click="doSearchCancel">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-list">
      <el-table
          border
          :data="resultList"
          style="width: 100%">
        <el-table-column
            align="center"
            prop="name"
            label="英文名">
        </el-table-column>
        <el-table-column
            prop="label"
            align="center"
            label="中文名">
        </el-table-column>
        <el-table-column
            width="180"
            align="center"
            label="消耗石头">
          <template slot-scope="scope">
            <span style="color: green " v-if="scope.row.payWith==='1'">{{ scope.row.price }} (绿色石头)</span>
            <span style="color: blue" v-if="scope.row.payWith==='2'">{{ scope.row.price }} (蓝色石头)</span>
            <span style="color: red" v-if="scope.row.payWith==='3'">{{ scope.row.price }} (红色石头)</span>
            <span style="color: #fafa03" v-if="scope.row.payWith==='4'">{{ scope.row.price }} (黄色石头)</span>
            <span style="color: #4EC9B0" v-if="scope.row.payWith==='5'">{{ scope.row.price }} (青色石头)</span>
            <span style="color: orange" v-if="scope.row.payWith==='6'">{{ scope.row.price }} (橙色石头)</span>
            <span style="color: #5c2699" v-if="scope.row.payWith==='7'">{{ scope.row.price }} (紫色石头)</span>
            <span v-if="scope.row.payWith===null || scope.row.payWith==='0'">免费</span>
          </template>
        </el-table-column>
        <el-table-column
            align="right"
            prop="createTime"
            label="创建时间">
        </el-table-column>
        <el-table-column
            align="right"
            width="300"
            label="操作">
          <template slot-scope="scope">
            <el-button type="info" size="medium" @click="toConfigPage(scope.row)">配置</el-button>
            <el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='马上删除'
                cancel-button-text='我后悔了'
                icon="el-icon-info"
                @confirm="deleteItem(scope.row)"
                icon-color="red"
                title="确定删除该游戏吗？">
              <el-button slot="reference" type="danger" style="margin-left: 10px;" size="medium">
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-part">
      <el-pagination
          size="small"
          background
          @current-change="loadByPage"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          layout="prev, pager, next"
          :total="pagination.total">
      </el-pagination>
    </div>
    <div class="dialog-part">
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :title="dialogText"
          center
          :visible.sync="isEditorShow"
          width="500px">
        <div class="editor-content">
          <el-form size="medium" label-width="100px">
<!--            <el-form-item label="模块" :required="true">-->
<!--              <el-cascader-->
<!--                  clearable-->
<!--                  v-model="selectModuleIds"-->
<!--                  :options="appModuleTreeData"-->
<!--                  :props="{ checkStrictly: true, value: 'id', label: 'name' }"-->
<!--                  :show-all-levels="true"-->
<!--                  @change="() => {}" placeholder="请选择数据的模块"></el-cascader>-->
<!--            </el-form-item>-->
            <el-form-item label="名称(EN)" required>
              <el-input v-model="game.name" placeholder="请输入英文/拼音名称"></el-input>
            </el-form-item>
            <el-form-item label="名称(CN)" required>
              <el-input placeholder="请输入中文名称" v-model="game.label"></el-input>
            </el-form-item>
<!--            <el-form-item label="石头" :required="true">-->
<!--              <el-select v-model="game.payWith">-->
<!--                <el-option value="0" label="免费"></el-option>-->
<!--                <el-option value="1" label="绿色石头"></el-option>-->
<!--                <el-option value="2" label="蓝色石头"></el-option>-->
<!--                <el-option value="3" label="红色石头"></el-option>-->
<!--&lt;!&ndash;                <el-option value="4" label="黄色石头"></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-option value="5" label="青色石头"></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-option value="6" label="黄色石头"></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-option value="7" label="紫色石头"></el-option>&ndash;&gt;-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="单价" :required="true" v-if="game.payWith!==null&&game.payWith!=='0'">-->
<!--              <el-input-number v-model="game.price" :min="1"></el-input-number>-->
<!--            </el-form-item>-->
          </el-form>
        </div>
        <div class="dialog-action" solt="footer" style="text-align: center">
          <el-button size="medium" @click="onEditorCancel">取 消</el-button>
          <el-button type="primary" size="medium" @click="onEditorConfirm">提 交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'

export default {
  data() {
    return {
      dialogText: '',
      search: {
        name: '',
        label: ''
      },
      pagination: {
        pageSize: 1,
        total: 0,
        currentPage: 1,
        totalPage: 1
      },
      isEditorShow: false,
      game: {
        name: '',
        label: '',
        price: 0,
        payWith: '0',
        moduleId: '0',
        id: ''
      },
      selectModuleIds: [],
      appModuleTreeData: [],
      resultList: []
    }
  },
  methods: {
    getModuleTreeData() {
      api.getAppModuleTree().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.appModuleTreeData = result.data;
        }
      })
    },
    deleteItem(item) {
      api.deleteGame(item.id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success(result.msg);
          this.listContent();
        } else {
          this.$message.error(result.msg);
        }
      })
    },
    toConfigPage(item) {
      let id = item.id;
      this.$router.push({
        path: '/word/game-config',
        query: {
          gameId: id,
          gameName: item.label
        }
      })
    },
    loadByPage(page) {
      this.pagination.currentPage = page;
      this.listContent();
    },
    listContent() {
      api.listGame(this.pagination.currentPage, this.search).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          let data = result.data;
          this.resultList = data.list;
          this.pagination.currentPage = data.currentPage;
          this.pagination.pageSize = data.pageSize;
          this.pagination.total = data.total;
          this.pagination.totalPage = data.totalPage;
        }
      })
    },
    onEditorCancel() {
      this.game.name = '';
      this.game.label = '';
      this.game.price = 0;
      this.game.payWith = '0';
      this.game.moduleId = '0';
      this.isEditorShow = false;
    },
    doSearchCancel() {
      this.search.name = '';
      this.search.label = '';
      this.doSearch();
    },
    doSearch() {
      this.pagination.currentPage = 1;
      this.listContent();
    },
    onEditorConfirm() {
      if (this.game.name === '') {
        return this.$message.error("请输入游戏的拼音.")
      }
      if (this.game.label === '') {
        return this.$message.error("请输入游戏的中文名.")
      }

      this.game.moduleId = this.selectModuleIds[this.selectModuleIds.length - 1];
      if (this.game.id !== '') {
        api.updateGame(this.game).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$message.success(result.msg);
            this.onEditorCancel();
            this.listContent();
          } else {
            this.$message.error(result.msg);
          }
        })
      } else {
        api.postGame(this.game).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$message.success(result.msg);
            this.onEditorCancel();
            this.listContent();
          } else {
            this.$message.error(result.msg);
          }
        })
      }
    },
    showEditor(item) {
      this.selectModuleIds = [];
      if (item) {
        this.game.name = item.name;
        this.game.label = item.label;
        this.game.id = item.id;
        this.game.price = item.price;
        this.game.payWith = item.payWith;
        this.game.moduleId = item.moduleId;
        this.selectModuleIds.push(item.moduleId)
        console.log("编辑游戏 编辑游戏", this.selectModuleIds, this.appModuleTreeData)
        this.dialogText = '编辑游戏';
      } else {
        this.dialogText = '创建游戏';
      }
      this.isEditorShow = true;
    }
  },
  mounted() {
    this.listContent();
    this.getModuleTreeData();
  }
}
</script>
<style>

</style>
